import JobCardList from "../JobCardList";
import TaskCardList from "../TaskCardList";
import {isTaskJob} from "./schedulerUtils";

export default function SchedulerCard({
    fieldSupervisorMap,
    fieldWorkerMap,
    isAgencyBlocked,
    isLoading,
    job,
    mobileAction,
    onEditJob,
    onJobUpdated,
    sameDayAssignmentLabel,
    sameDaySchedule,
    dragSourceZone,
}) {
    const taskJob = isTaskJob(job);
    const sharedProps = {
        fieldWorkerMap,
        isLoading,
        isAgencyBlocked,
        job,
        mobileAction,
        onEditJob,
        sameDayAssignmentLabel,
        sameDaySchedule,
        dragSourceZone,
    };

    return taskJob ? (
        <TaskCardList {...sharedProps} />
    ) : (
        <JobCardList
            {...sharedProps}
            fieldSupervisorMap={fieldSupervisorMap}
            onJobUpdated={onJobUpdated}
        />
    );
}
